import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { DialogContent, DialogActions, Button, TextField, Stack } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { useApi } from "../../../utils/Api";
import Translate from "../../../utils/Translate";
import { getCurrentDateMask, getCurrentInputFormat } from "../../../utils/dateTimeFormat";

export default function FreeSampleEditDialog({ row, onSaved }) {
  const api = useApi();
  const navigate = useNavigate();
  const [name, setName] = useState(row.name ?? "");
  const [version, setVersion] = useState(row.version ?? "");
  const [availableFromDate, setAvailableFromDate] = useState(row.availableFromDate ? new Date(row.availableFromDate) : null);
  const [availableUntilDate, setAvailableUntilDate] = useState(row.availableUntilDate ? new Date(row.availableUntilDate) : null);
  const [submitting, setSubmitting] = useState(false);

  async function handleSave() {
    setSubmitting(true);
    const payload = {
      agreementPartFreeSampleId: row.agreementPartFreeSampleId,
      partId: row.partId,
      name,
      version,
      availableFromDate,
      availableUntilDate,
    };
    const response = await api.fetch(
      `${import.meta.env.VITE_MAIN_URL}agreements/instructor-material/free-samples`,
      payload,
      "PUT",
    );
    setSubmitting(false);
    if (response && response.isSuccessful) {
      if (onSaved) {
        onSaved();
      }
      navigate(-1);
    }
  }

  const canSave = !!name && !!availableFromDate && !!availableUntilDate && !submitting;

  return (
    <>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1, minWidth: 360 }}>
          <TextField
            label={Translate.get("Name")}
            value={name}
            onChange={(e) => setName(e.target.value)}
            fullWidth
            required
          />
          <TextField
            label={Translate.get("Version")}
            value={version}
            onChange={(e) => setVersion(e.target.value)}
            fullWidth
          />
          <DatePicker
            format={getCurrentInputFormat()}
            mask={getCurrentDateMask()}
            label={Translate.get("AvailableFromDate")}
            value={availableFromDate}
            onChange={(newValue) => setAvailableFromDate(newValue)}
            slotProps={{ textField: { required: true, fullWidth: true } }}
          />
          <DatePicker
            format={getCurrentInputFormat()}
            mask={getCurrentDateMask()}
            label={Translate.get("AvailableToDate")}
            value={availableUntilDate}
            onChange={(newValue) => setAvailableUntilDate(newValue)}
            slotProps={{ textField: { required: true, fullWidth: true } }}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => navigate(-1)}>{Translate.get("Cancel")}</Button>
        <Button variant="contained" onClick={handleSave} disabled={!canSave}>
          {Translate.get("Save")}
        </Button>
      </DialogActions>
    </>
  );
}
